import { AfterViewInit, Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { assets } from '../../core/constants/assets.const';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialog } from '@angular/material/dialog';
import { SyncCalenderComponent } from '../../modals/sync-calender/sync-calender.component';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { UserResponse } from '../../models/auth.model';
import { BaseClass } from '../../shared/class/baseClass';
import { environment } from '../../../environments/environment';
import { UserRole } from '../../core/constants/keys.constant';
import { SearchComponent } from '../../shared/components/search/search.component';
import { MatIconModule } from '@angular/material/icon';
import { SocketService } from '../../services/socket.service';

@Component({
  selector: 'mindbase-main',
  standalone: true,
  imports: [MatSidenavModule, MatMenuModule, CommonModule, RouterModule, SharedModule, TranslateModule, MatBadgeModule, SearchComponent, MatIconModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent extends BaseClass implements OnInit, AfterViewInit, OnDestroy {
  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected profile: UserResponse | null = null;
  public assets = assets;
  public sidenavWidth = 200;
  protected url: any;
  protected currentPath: 'tutorCounselor' | 'studentParent' = 'studentParent';
  protected userRole = UserRole;
  constructor(injector: Injector, private dialog: MatDialog,  private _socketService: SocketService) {
    super(injector);
  }

  ngOnInit(): void {
    this.subscriptionSubject$ = this.authService.profileDetailsSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((res: UserResponse | null) => {
        if (res !== null) {
          this.profile = res;
          this.setSw(this.profile.role);
          if (this.profile.role === UserRole.TUTOR || this.profile.role === UserRole.COUNSELOR) {
            this.currentPath = 'tutorCounselor';
          } else {
            this.currentPath = 'studentParent';
          }
        } else {
          if (localStorage.getItem(environment.storageKey)) {
            this.getProfile();
          }
        }
      });
    this.initializeSocket();
    const fcmToken = localStorage.getItem('fcmToken');
    this.authService.deviceTokenSubject.next(fcmToken);
  }

  private initializeSocket(): void {
    this._socketService.initSocket();
  }

  ngAfterViewInit(): void {
    this.permissionsUpdate();
  }

  getProfile(): void {
    this._spinnerService.addToLoader('getProfile');
    this.authService
      .getProfile()
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: (res: UserResponse) => {
          this._spinnerService.removeFromLoader('getProfile');
          this.profile = res;
          this.setSw(this.profile.role);
          if (this.profile.role === UserRole.TUTOR || this.profile.role === UserRole.COUNSELOR) {
            this.currentPath = 'tutorCounselor';
          } else {
            this.currentPath = 'studentParent';
          }
          this.authService.profileDetailsSubject.next(res);
        },
        error: () => {
          this._spinnerService.removeFromLoader('getProfile');
        }
      });
  }

  setSw(role: number): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    navigator.serviceWorker.ready.then((registration) => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller?.postMessage({
          type: 'role',
          roleData: role
        });
      }
    });
  }

  handleRouteNavigation(): void {
    if (this.profile?.role === UserRole.STUDENT || this.profile?.role === UserRole.PARENT) {
      this.router.navigate(['/my-profile']);
    } else if (this.profile?.role === UserRole.TUTOR || this.profile?.role === UserRole.COUNSELOR) {
      this.router.navigate(['/tutor/profile']);
    }
  }

  toggleSidenav(): void {
    this.authService.toggleSidebarView();
  }
  syncCalender(): void {
    const dialogRef = this.dialog.open(SyncCalenderComponent, {});
    dialogRef.afterClosed().subscribe(() => { });
  }

  onImageError(event: any): void {
    (event.target as HTMLImageElement).src =  assets.userPlaceholderLogo;
  }

  private permissionsUpdate(): void {
    this._socketService.onEvent('permissionsUpdatedOk').subscribe({
      next: (res: any) => { 
        this.authService.permissionUpdate.next(res.data);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.unsubscribe();
  }
}
